"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var styled_components_1 = __importDefault(require("styled-components"));
var react_1 = __importDefault(require("react"));
var PaypalCheckoutBtn_1 = __importDefault(require("../PaypalCheckoutBtn"));
var CheckoutSummary = function CheckoutSummary(props) {
  var cart = props.cart,
    onClick = props.onClick,
    _a = props.disabled,
    disabled = _a === void 0 ? false : _a,
    _b = props.buttonLabel,
    buttonLabel = _b === void 0 ? '下一步' : _b,
    _c = props.prevButtonLabel,
    prevButtonLabel = _c === void 0 ? '上一步' : _c,
    onPrevClick = props.onPrevClick,
    renderExtraCheckoutSummary = props.renderExtraCheckoutSummary,
    _d = props.lastStep,
    lastStep = _d === void 0 ? false : _d,
    onPaypalApprove = props.onPaypalApprove;
  var fees = __spreadArray([], cart.extra_items.map(function (i) {
    return __assign(__assign({}, i), {
      type: 'extra'
    });
  }));
  var discounts = __spreadArray([], cart.discount_items.map(function (i) {
    return __assign(__assign({}, i), {
      type: 'discount'
    });
  }));
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement("div", {
    className: "detail-info"
  }, react_1.default.createElement("h2", {
    className: "header"
  }, "\u91D1\u984D\u8CC7\u8A0A"), react_1.default.createElement("div", {
    className: "price-table"
  }, react_1.default.createElement("div", {
    className: "item subtotal"
  }, react_1.default.createElement("h4", {
    className: "label"
  }, "\u5C0F\u8A08"), react_1.default.createElement("h4", {
    className: "value"
  }, "$", cart.subtotal)), fees.map(function (fee, index) {
    return react_1.default.createElement("div", {
      className: "item fee",
      key: index
    }, react_1.default.createElement("h4", {
      className: "label"
    }, fee.name), react_1.default.createElement("h4", {
      className: "value"
    }, "$", fee.amount));
  }), discounts.map(function (discount, index) {
    return react_1.default.createElement("div", {
      className: "item discount",
      key: index
    }, react_1.default.createElement("h4", {
      className: "label"
    }, discount.name), react_1.default.createElement("h4", {
      className: "value"
    }, discount.amount > 0 ? "- $" + discount.amount : "+ $" + -discount.amount));
  }), react_1.default.createElement("div", {
    className: "item total"
  }, react_1.default.createElement("h2", {
    className: "label"
  }, "\u7E3D\u91D1\u984D"), react_1.default.createElement("h2", {
    className: "value"
  }, "$", cart.total))), props.children), renderExtraCheckoutSummary && renderExtraCheckoutSummary({
    cart: cart
  }), lastStep && cart.payment_subtype === 'paypal' ? react_1.default.createElement(PaypalCheckoutBtn_1.default, {
    onCreateOrder: onClick,
    onApprove: onPaypalApprove
  }) : react_1.default.createElement("button", {
    id: "checkout-btn",
    className: "step-btn next-step",
    disabled: disabled,
    onClick: onClick
  }, react_1.default.createElement("div", null, buttonLabel)), react_1.default.createElement("button", {
    className: "step-btn prev-step",
    onClick: onPrevClick
  }, react_1.default.createElement("div", null, prevButtonLabel)));
};
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  & > .detail-info {\n    background-color: white;\n    padding: 0 10px 10px 10px;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n    overflow-y: auto;\n    overflow-x: hidden;\n    transition: all 150ms;\n    margin-bottom: 20px;\n\n    & > h2.header {\n      font-size: 1.33rem;\n      padding: 10px 0;\n    }\n\n    & > .price-table {\n      & > *.item {\n        display: flex;\n        align-items: center;\n        border-bottom: 1px solid #aaa;\n        padding: 8px 0;\n\n        & h2,\n        h4 {\n          color: #aaa;\n        }\n\n        & > .label {\n          flex: 1;\n        }\n      }\n\n      & > *.item:first-child {\n        border-top: 1px solid #aaa;\n      }\n\n      & > *.item.total {\n        & > .value {\n          color: red;\n        }\n      }\n    }\n  }\n\n  & > button.step-btn {\n    width: 100%;\n    border-radius: 100px;\n    padding: 8px 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    border: none;\n    transition: all 200ms;\n    cursor: pointer;\n\n    &:hover {\n      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.5);\n    }\n\n    &:active {\n      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);\n    }\n\n    &:not(:last-child) {\n      margin-bottom: 10px;\n    }\n\n    &.next-step {\n      background-color: teal;\n      color: white;\n    }\n\n    &.prev-step {\n      background-color: #ccc;\n      color: white;\n    }\n  }\n"], ["\n  position: relative;\n\n  & > .detail-info {\n    background-color: white;\n    padding: 0 10px 10px 10px;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n    overflow-y: auto;\n    overflow-x: hidden;\n    transition: all 150ms;\n    margin-bottom: 20px;\n\n    & > h2.header {\n      font-size: 1.33rem;\n      padding: 10px 0;\n    }\n\n    & > .price-table {\n      & > *.item {\n        display: flex;\n        align-items: center;\n        border-bottom: 1px solid #aaa;\n        padding: 8px 0;\n\n        & h2,\n        h4 {\n          color: #aaa;\n        }\n\n        & > .label {\n          flex: 1;\n        }\n      }\n\n      & > *.item:first-child {\n        border-top: 1px solid #aaa;\n      }\n\n      & > *.item.total {\n        & > .value {\n          color: red;\n        }\n      }\n    }\n  }\n\n  & > button.step-btn {\n    width: 100%;\n    border-radius: 100px;\n    padding: 8px 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    border: none;\n    transition: all 200ms;\n    cursor: pointer;\n\n    &:hover {\n      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.5);\n    }\n\n    &:active {\n      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);\n    }\n\n    &:not(:last-child) {\n      margin-bottom: 10px;\n    }\n\n    &.next-step {\n      background-color: teal;\n      color: white;\n    }\n\n    &.prev-step {\n      background-color: #ccc;\n      color: white;\n    }\n  }\n"])));
exports.default = CheckoutSummary;
var templateObject_1;